import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GlobalStateContext } from "../../store/GlobalState";
import { jwtDecode } from "jwt-decode";

export const authSlice = createSlice({
  name: "auth",
  initialState: () => {
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      const refreshToken = localStorage.getItem('refreshToken')
      const user = localStorage.getItem('user')
      const expires = localStorage.getItem('expires')
      const claims = jwtDecode(accessToken) as any
      const role = claims.Role
      const permission = claims.Permission
      return {
        user: user,
        refreshToken: refreshToken,
        accessToken: accessToken,
        expires: expires,
        role: role,
        permissions: permission,
      }
    }

    return {
      user: null,
      refreshToken: null,
      accessToken: null,
      expires: null,
      role: null,
      permissions: null,
    }
  },
  reducers: {
    setCredentials: (state, action) => {
      //   state.isOpen = !state.isOpen;
      const { user, refreshToken, accessToken, expires } = action.payload
      state.user = user
      state.refreshToken = refreshToken
      state.accessToken = accessToken
      const claims = jwtDecode(accessToken) as any
      state.role = claims.Role
      state.permissions = claims.Permission

      state.expires = expires
      console.log("auth state set")
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('user', user);
      localStorage.setItem('expires', expires);
    },
    logOut: (state) => {
      state.user = null
      state.refreshToken = null
      state.accessToken = null
      state.expires = null
      state.role = null
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state: any) => state.auth.user
export const selectAccessToken = (state: any) => state.auth.accessToken
export const selectRefreshToken = (state: any) => state.auth.refreshToken
export const selectExpires = (state: any) => state.auth.expires
export const selectRole = (state: any) => state.auth.role
export const selectPermissions: (x: any) => string[] = (state: any) => state.auth.permissions ?? []